import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-white px-4 py-9 sm:px-6 sm:py-12" data-id="element-77" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-2xl gap-3 rounded-xl border border-brand/20 bg-brand-soft p-4 text-left sm:gap-4 sm:p-5" data-id="element-78" data-mp="4x32ltaq3dfv">
        <ShieldCheckIcon className="h-8 w-8 shrink-0 text-brand sm:h-10 sm:w-10" aria-hidden="true" data-id="element-79" data-mp="etpo8kavi8iy" />
        <div data-id="element-80" data-mp="js0ygw52yl1p">
          <h2 className="font-display text-[0.95rem] font-extrabold uppercase tracking-wide text-brand-deep sm:text-lg" data-id="element-81" data-mp="jsaf3t48jfuq">
            Garantía de 7 días
          </h2>
          <p className="mt-1 text-[0.82rem] leading-snug text-gray-700 sm:text-[0.95rem]" data-id="element-82" data-mp="slvtvcgegx45">
            Revisa el contenido, aplica los primeros pasos y comprueba si el
            método es para ti. Si no lo es, puedes solicitar la devolución de tu
            dinero según las condiciones de garantía, dentro de los 7 días.
          </p>
        </div>
      </div>
    </section>;
}